import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { blockFormPostsOffLiveSite } from "@/utils/liveSite";

// Off the live site (e.g. PR previews), forms must never reach the live Function App
blockFormPostsOffLiveSite(process.env.REACT_APP_BACKEND_URL);

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If the root has pre-rendered children (from react-snap), hydrate instead of full render
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
